import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const asJson = <T>(
  wrappedSerializer: Serializer<T>,
): Serializer<T> & SerializerExtensions<T> => ({
  deserialize: (raw) => wrappedSerializer.deserialize(JSON.parse(raw)),
  serialize: (input) => JSON.stringify(wrappedSerializer.serialize(input)),
  ...serializerExtensions(),
});
